import type OlMap from "ol/Map";

const RELEASE_DRAW_TOOLS_EVENT = "releasedrawtools";

/**
 * 켜져 있는 그리기 도구를 끄게 한다 — 도구의 켜짐 상태는 각 툴바 묶음 안에 있어 밖에서 직접 끌 수 없으므로,
 * 지도에 신호를 보내고 모든 그리기 버튼이 쓰는 손짓 훅이 받아 스스로 해제한다(Esc 와 같은 경로).
 * 지도 클릭을 따로 쓰는 기능(장비 배치 등)이 시작할 때 부른다.
 */
export function releaseDrawTools(map: OlMap): void {
  map.dispatchEvent(RELEASE_DRAW_TOOLS_EVENT);
}

/** 그리기 도구가 켜져 있는 동안 해제 신호를 듣는다. 해제 함수를 돌려준다. */
export function onReleaseDrawTools(map: OlMap, listener: () => void) {
  // OL 의 on/un 타입은 내장 이벤트 이름만 받는다 — 사용자 이벤트도 같은 디스패처를 탄다
  const on = map.on as (type: string, listener: () => void) => unknown;
  const un = map.un as (type: string, listener: () => void) => void;
  on.call(map, RELEASE_DRAW_TOOLS_EVENT, listener);
  return () => un.call(map, RELEASE_DRAW_TOOLS_EVENT, listener);
}
